import React, { useMemo } from "react";

import { Language, Order } from "../../../../../../../services";
import { ColumnId } from "../../columns";
import { CellContentRoot } from "..";

import cellProcessing from "./cellProcessing";

const PickupSectorCellContent: React.FC<PickupSectorCellContent.Props> = ({
	item,
	language,
}) => {
	const content = useMemo(() => {
		const isCellsReady = !!item?.cellsForTableSettings?.isCellsReady;

		const isLanguageMatched =
			item?.cellsForTableSettings?.lang === language;

		const preparedCell = item?.cellsForTable?.[ColumnId.PickupSector];

		if (
			isCellsReady &&
			isLanguageMatched &&
			preparedCell != null
		) {
			return preparedCell;
		}

		return cellProcessing(item, language);
	}, [item, language]);

	return (
		<CellContentRoot alignItems="center" h="100%" w="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace PickupSectorCellContent {
	interface Props {
		item: Order.Model;

		language: Language;
	}
}

export default PickupSectorCellContent;
